import { formatPrismicData } from '@monofront/business/utils';
import { IBubblesInTabs } from './BubblesInTabs';

export const mapBubblesInTabs = ({ prismicContent }): IBubblesInTabs => {
  const { primary, items }: IBubblesInTabs = formatPrismicData(prismicContent);

  return {
    primary,
    items,
  };
};
